module.exports = __webpack_public_path__ + "static/media/loggly-logo-white.09b8b4ca.svg";